import { BASE_URL, MOBILE_BASE_URL } from "../api_const"

export const PRODUCTS_BASE_URL = BASE_URL + "/product"
export const URL_FETCH_ALL_PRODUCTS= PRODUCTS_BASE_URL + "/all"
export const GET_DETAILS_PRODUCTS_BY_ID = PRODUCTS_BASE_URL + "/details"